import styled from "styled-components";

interface ContainerProps {
    $isDragging?: boolean;
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;

    border-radius: 6px;
    padding: 30px;
    transition: all 0.3s ease;
    border: 2px dotted ${({ theme }) => theme.colors.interfaceGray200};
    
    ${({ $isDragging, theme }) => $isDragging && `
        background-color: ${theme.colors.primaryRed50 || 'rgba(239, 68, 68, 0.08)'};
        border-color: ${theme.colors.primaryRed400 || '#ef4444'};
    `}


    .upload-container {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme.colors.interfacePure100};
        svg {
            width: 30px;
            height: 30px;
            path {
                color: ${({ theme }) => theme.colors.interfaceGray200};
            }
        }
    }

    .input-container {
        > button {
            font-size: 12px;
            width: 100%;
            > svg {
                width: 16px;
                height: 16px;
            }
        }
    }

    .texto-anexos {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;

        .main {
            font-size: 16px;
            font-weight: 600;
            color: ${({ theme }) => theme.colors.c000000};
        }

        .secundario {
            font-size: 12px;
            font-weight: 400;
            color: ${({ theme }) => theme.colors.interfaceGray400};
        }
    }
`;